import { useState, useEffect, useCallback } from "react";
import { 
  MagnifyingGlassIcon, 
  PlusIcon, 
  ArrowDownOnSquareIcon, 
  ArchiveBoxIcon 
} from "@heroicons/react/24/solid";
import debounce from "lodash/debounce";

export default function ProspectSearchBar({ 
  prospects, 
  setProspectsFiltres, 
  onAdd, 
  onExport, 
  onArchiveView 
}) {
  const [searchTerm, setSearchTerm] = useState("");

  // ✅ Fonction debounce pour éviter les appels trop fréquents
  const debouncedSearch = useCallback(
    debounce((value) => {
      let filtered = prospects;

      if (value) {
        filtered = filtered.filter((prospect) =>
          Object.values(prospect).some(
            (val) =>
              val &&
              val.toString().toLowerCase().includes(value.toLowerCase())
          )
        );
      }

      setProspectsFiltres(filtered);
    }, 200),
    [prospects, setProspectsFiltres]
  );

  useEffect(() => {
    debouncedSearch(searchTerm);
    return () => debouncedSearch.cancel();
  }, [searchTerm, debouncedSearch]);

  return (
    <div className="flex items-center justify-between space-x-4 mb-4">
      {/* 🔍 Barre de recherche */}
      <div className="relative flex-1">
        <MagnifyingGlassIcon className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
        <input
          type="text"
          className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="Rechercher un prospect..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* 📥 Bouton Export */}
      <button
        className="flex items-center px-4 py-2 border border-gray-300 bg-white rounded-lg hover:bg-gray-100"
        onClick={onExport}
      >
        <ArrowDownOnSquareIcon className="h-5 w-5 text-gray-600" />
        <span className="ml-2">Exporter</span>
      </button>

      {/* ➕ Nouvelle fiche / 📦 Archives */}
      <div className="flex items-center gap-3">
        <button
          className="flex items-center space-x-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          onClick={onAdd}
        >
          <PlusIcon className="h-5 w-5 text-white" />
          <span>Nouvelle Fiche</span>
        </button>

        {/* ➖ Barre verticale */}
        <div className="w-px h-6 bg-gray-300" />

        <button
          className="flex items-center space-x-2 px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
          onClick={onArchiveView}
        >
          <ArchiveBoxIcon className="h-5 w-5" />
          <span>Archives</span>
        </button>
      </div>
    </div>
  );
}
